//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery/dist/jquery.min.js'
import { validationMixin } from 'vuelidate'
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
  helpers
} from 'vuelidate/lib/validators'
import isURL from 'validator/lib/isURL'
import { v4 as uuidv4 } from 'uuid'
import { esaEncryptData } from '~/plugins/secret'

const corporateEmail = (value) => {
  const match = /^\w+[-.\w]*@(\w+[-.\w]*?\.\w{2,4})$/.exec(value)
  const forbiddenDomains = [
    'hotmail.com',
    'outlook.com',
    'gmail.com',
    'yahoo.com'
  ]
  if (
    !match ||
    !match.length ||
    match.length < 2 ||
    forbiddenDomains.includes(match[1].toLowerCase())
  ) {
    return false
  }
  return true
}
const url = helpers.withParams(
  { type: 'url' },
  value => !helpers.req(value) || !!isURL(value)
)

export default {
  name: 'IGamingPaymentSolution',
  components: { },
  mixins: [validationMixin],
  layout: 'single-default',
  data () {
    return {
      form: {
        name: '',
        areaCode: this.getAreaCode(),
        phone: '',
        email: '',
        transactionVolume: '',
        company: '',
        companyWebsite: '',
        industry: '',
        knowUs: '',
        // country: '',
        // companySize: '',
        // latamTransactions: '',
        usageCountries: []
      },
      sendingData: false,
      errorMessage: '',
      knowUsOption: this.getKnowUs(),
      industryOptions: this.getIndustryOpt(),
      transactionVolumeOptions: this.getTransactions(),
      countries: [],
      countriesList: require('@/components/contactus/countries.json'),
      employees: this.getEmployeesNumber(),
      transaction: this.getTransactions(),
      serviceCountriesOpt: this.getServiceCountryOpt()
    }
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(50)
      },
      phone: {
        required,
        numeric,
        minLength: minLength(7),
        maxLength: maxLength(11)
      },
      email: {
        required,
        email,
        corporateEmail,
        maxLength: maxLength(255)
      },
      transactionVolume: {
        required
      },
      company: {
        required,
        maxLength: maxLength(100)
      },
      companyWebsite: {
        required,
        url,
        maxLength: maxLength(300)
      },
      // companySize: {
      //   required
      // },
      // country: {
      //   required
      // },
      // latamTransactions: {
      //   required
      // },
      industry: {
        required
      },
      knowUs: {
        required
      },
      usageCountries: {
        required,
        minLength: minLength(1)
      }
    }
  },
  computed: {
    isAllSelected () {
      if (
        this.serviceCountriesOpt &&
        this.serviceCountriesOpt.length &&
        this.form.usageCountries &&
        this.form.usageCountries.length
      ) {
        return (
          this.serviceCountriesOpt.length === this.form.usageCountries.length
        )
      }
      return false
    }
  },
  beforeUpdate () {
    /* fix the solutions not updating on language change */
    if (this.current_language !== this.$i18n.locale) {
      this.industryOptions = this.getIndustryOpt()
      this.knowUsOption = this.getKnowUs()
    }
  },
  mounted () {
    this.resetForm()
    this.form.areaCode = this.getAreaCode()
    this.countries = this.getCountries()
    this.employees = this.getEmployeesNumber()
    this.transaction = this.getTransactions()
    this.serviceCountriesOpt = this.getServiceCountryOpt()
  },
  methods: {
    getQueryString (name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      const r = window.location.search.substring(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    getIndustryOpt () {
      return [
        { displayName: 'Digital Content', value: '1' },
        { displayName: 'E - Commerce', value: '2' },
        { displayName: 'FX', value: '3' },
        { displayName: 'Game', value: '4' },
        { displayName: 'IT Technical Service', value: '5' },
        { displayName: 'Logistics', value: '6' },
        { displayName: 'Marketing', value: '7' },
        { displayName: 'Service', value: '8' },
        { displayName: 'Securities Dealer', value: '9' },
        { displayName: 'PSP (Internal)', value: '10' },
        { displayName: 'PSP', value: '11' },
        { displayName: 'Others', value: '12' },
        { displayName: 'Social', value: '13' },
        { displayName: 'OTA', value: '14' },
        { displayName: 'Advertising', value: '15' },
        { displayName: 'Gaming', value: '16' }
      ]
    },
    getKnowUs () {
      return [
        {
          value: 'Referral',
          displayName: 'Referral'
        },
        {
          value: 'Linkedin',
          displayName: 'Linkedin'
        },
        {
          value: 'Google',
          displayName: 'Google'
        },
        {
          value: 'News / Blogs / Magazines',
          displayName: 'News / Blogs / Magazines'
        },
        {
          value: 'Other',
          displayName: 'Other'
        }
      ]
    },
    getServiceCountryOpt () {
      return [
        {
          text: 'Hong Kong',
          value: 'HKG'
        },
        {
          text: 'Other',
          value: 'other'
        }
      ]
    },
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    onSubmit () {
      // console.log(this.form)
      const self = this
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.errorMessage = 'There may be fields with errors, please review the form and try again'
        return
      }
      const uuid = uuidv4().replace(/-/g, '')
      const pagsmileUrl = `${process.env.APIURL}/website/common/account/apply`
      const { name, phone, email, transactionVolume, company, companyWebsite, industry, knowUs, areaCode, usageCountries } = this.form
      const data = {
        basic_info: {
          full_name: name,
          phone_number: phone,
          business_email: email,
          global_transaction_volume: transactionVolume,
          company_name: company,
          company_website: companyWebsite,
          industry,
          info_sources: knowUs,
          area_code: areaCode
        },
        region: usageCountries,
        endpoint: 'card'
      }
      console.log('data -> ', JSON.stringify(data))
      const settings = {
        url: pagsmileUrl,
        method: 'POST',
        timeout: 0,
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          key: this.$encrypt(uuid),
          data: esaEncryptData(JSON.stringify(data), uuid)
        })
      }
      this.sendingData = true
      $.ajax(settings)
        .done(function (response) {
          self.sendingData = false
          if (response.code === '10000') {
            self.$toast.success(response.msg, { timeout: 2000 })
            self.errorMessage = ''
            self.resetForm()
            return true
          } else {
            console.log('Error: ', response.msg)
            self.$toast.error(response.msg)
          }
        })
        .catch((error) => {
          console.log('Error: ', error)
          self.sendingData = false
        })
    },
    resetForm () {
      this.errorMessage = ''
      this.sendingData = false
      this.form = {
        name: '',
        areaCode: this.getAreaCode(),
        phone: '',
        email: '',
        transactionVolume: '',
        company: '',
        companyWebsite: '',
        // companySize: '',
        // country: '',
        // latamTransactions: '',
        industry: '',
        knowUs: '',
        usageCountries: []
      }
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    getCountries () {
      if (this.countriesList && this.countriesList.length) {
        const cntrs = [...this.countriesList]
        const uniqueIds = new Set()
        const uniqueCountries = cntrs.filter((country) => {
          const isDuplicate = uniqueIds.has(country.countryName)
          if (!isDuplicate) {
            uniqueIds.add(country.countryName)
            return true
          }
          return false
        })
        uniqueCountries.forEach((country) => {
          if (typeof country.code === 'string') {
            country.iso2 = country.code.substring(0, 2).toUpperCase()
            country.iso3 = country.code.substring(5).toUpperCase()
            if (this.$i18n.locale !== 'en') {
              country.displayName = this.$i18n.t(country.iso2.toLowerCase())
            } else {
              country.displayName = country.countryName
            }
          }
        })
        return uniqueCountries
      }
      return []
    },
    getAreaCode () {
      if (this.$i18n.locale === 'zh') {
        return '86'
      } else {
        return '55'
      }
    },
    getEmployeesNumber () {
      return [
        {
          value: 'none',
          displayName: 'Number of employees',
          disabled: true
        },
        {
          value: '1-10',
          displayName: '1-10'
        },
        {
          value: '11-50',
          displayName: '11-50'
        },
        {
          value: '51-100',
          displayName: '51-100'
        },
        {
          value: '101-1000',
          displayName: '101-1000'
        },
        {
          value: '1000-More',
          displayName: '1000+'
        }
      ]
    },
    getTransactions () {
      return [
        {
          value: '$0-$500k',
          displayName: '$0 - $500k USD'
        },
        {
          value: '$500k-$999k',
          displayName: '$500k - $999k USD'
        },
        {
          value: '$1M-$9M',
          displayName: '$1M - $9M USD'
        },
        {
          value: '$10M-$50M',
          displayName: '$10M - $50M USD'
        },
        {
          value: '$51M-$100M',
          displayName: '$51M - $100M USD'
        },
        {
          value: '$100M-More',
          displayName: '$100M+ USD'
        }
      ]
    }
    // selectAllCountries () {
    //   const checkboxes = document.getElementsByName('usage-countries-field')
    //   const checkboxesArr = [...checkboxes]
    //   const checkedValue = !this.isAllSelected
    //   checkboxesArr.forEach((checkbox) => {
    //     if (checkbox.checked !== checkedValue) {
    //       checkbox.click()
    //     }
    //   })
    // }
  }
}
